import React, { useState, useEffect, useRef } from "react";
import Marquee from "react-fast-marquee";

const MarqueeComponent = ({
  content,
  spanClassName = "text-sm font-medium",
}) => {
  const [shouldUseMarquee, setShouldUseMarquee] = useState(false);
  const [isMarqueeRunning, setIsMarqueeRunning] = useState(true);
  const contentRef = useRef(null);

  useEffect(() => {
    // check if overflow screen
    const checkWidth = () => {
      if (contentRef.current) {
        const shouldMarquee =
          contentRef.current.offsetWidth < contentRef.current.scrollWidth ||
          contentRef.current.offsetHeight < contentRef.current.scrollHeight;
        setShouldUseMarquee(shouldMarquee);
      }
    };

    checkWidth();
    window.addEventListener("resize", checkWidth);

    return () => window.removeEventListener("resize", checkWidth);
  }, [content]);

  if (shouldUseMarquee) {
    return (
      <Marquee
        play={isMarqueeRunning}
        onCycleComplete={() => {
          setIsMarqueeRunning(false);
          setTimeout(() => setIsMarqueeRunning(true), 3000);
        }}
      >
        <span
          className={`${spanClassName} line-clamp-1`}
        >{`${content}\u00A0\u00A0`}</span>
      </Marquee>
    );
  } else {
    return (
      <div ref={contentRef}>
        <span className={`${spanClassName} line-clamp-1 w-max`}>{content}</span>
      </div>
    );
  }
};

export default MarqueeComponent;
